<!-- SPDX-License-Identifier: AGPL-3.0-or-later -->

<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer mode="side" opened="true" fixedInViewport="true">
    <mat-toolbar color="primary">BeerBrawl</mat-toolbar>
    <app-sidebar></app-sidebar>
  </mat-sidenav>
  <mat-sidenav-content>
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
